import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, HeaderTitle, Icon, Label } from '@atlas/ui';

const PaymentLoadingPopup = ({ data, id }) => {
  const { headerTitle, paymentDetails, text, title } = data;
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className="loading-modal">
      <HeaderTitle className="left border block-big size-xs" title={headerTitle}>
        <div className="header-title__children">
          <button onClick={handleClose} type="button">
            <Icon name="close" />
          </button>
        </div>
      </HeaderTitle>

      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
        {paymentDetails && (
          <div className="popup__payment-details">
            {paymentDetails?.value && (
              <span className="payment-amount">{paymentDetails?.value}</span>
            )}
            {paymentDetails?.paymentMethod && (
              <span className="payment-method-name">{paymentDetails?.paymentMethod}</span>
            )}
          </div>
        )}
        <div className="popup__loader" />
      </div>
    </BasePopup>
  );
};

PaymentLoadingPopup.propTypes = {
  data: PropTypes.shape({
    headerTitle: PropTypes.string,
    paymentDetails: PropTypes.shape({
      paymentMethod: PropTypes.string,
      value: PropTypes.string,
    }),
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PaymentLoadingPopup;
